import axios from "axios";
import { format } from "date-fns";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { AdvisorInfoSchema } from "../Types";
export const url = (advisorId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/entity/advisor/${advisorId}`
    : `https://middleware.uat.farther.com/entity/advisor/${advisorId}`;
export const PatchAdvisor = z
    .object({
    description: z.string().nullable(),
    hometown: z.string().nullable(),
    location: z.string().nullable(),
    concentration: z.string().nullable(),
    experienceStartYear: z.number().int().min(1950).max(2030).nullable(),
    pershingRrCode: z.string().nullable(),
    headshotPath: z.string().url().nullable(),
    headshotFile: z.instanceof(File).optional(),
    calendarUrl: z.string().url().nullable(),
    linkedinUrl: z.string().url().nullable(),
    almaMaters: z.array(z.string()).nullable(),
    funFacts: z.array(z.string()).nullable(),
    isAvailable: z.boolean(),
    apexAdvisorId: z.number().nullable(),
})
    .partial()
    .strict();
export default async function patchAdvisor(advisorId, body, config) {
    const logBodies = Object.entries(body)
        .filter(([key]) => key !== "headshotFile") // Exclude file from logging
        .map(([key, value]) => `${key}:${value}`)
        .join("-");
    const dayCapture = format(new Date(), "yyyy-MM-dd:HH:mm:ss");
    const idemKey = `${advisorId}_${config.advisorId}_${logBodies}_${dayCapture}`;
    // Check if we need to send as FormData (for file upload) or JSON
    const hasFile = body.headshotFile instanceof File;
    let requestData;
    let contentType;
    if (hasFile) {
        // Create FormData for file upload
        const formData = new FormData();
        // Add all non-file fields properly to FormData
        Object.entries(body).forEach(([key, value]) => {
            if (key === "headshotFile" && value instanceof File) {
                formData.append(key, value);
            }
            else if (value !== undefined && value !== null) {
                if (Array.isArray(value)) {
                    // Append each array item with the same key name for proper backend parsing
                    value.forEach((item) => {
                        formData.append(key, String(item));
                    });
                }
                else {
                    formData.append(key, String(value));
                }
            }
        });
        requestData = formData;
        // Don't set Content-Type header - let browser set it with boundary
        contentType = undefined;
    }
    else {
        // Send as JSON for non-file requests
        requestData = body;
        contentType = "application/json";
    }
    const headers = {
        Authorization: `Bearer ${config.jwt}`,
        Advisor: config.advisorId,
        Version: "20250610",
        "Idempotency-Key": idemKey,
    };
    if (contentType !== undefined) {
        headers["Content-Type"] = contentType;
    }
    const { data } = await axios.patch(url(advisorId), requestData, {
        headers,
    });
    const decoded = AdvisorInfoSchema.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[patchAdvisor] Could not parse";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=patchAdvisor.js.map